module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-footer"
  }, [_c('div', {
    staticClass: "footer-tabbar"
  }, [_c('router-link', {
    staticClass: "tabbar-item",
    attrs: {
      "to": {
        name: 'rental'
      },
      "exact": ""
    }
  }, [_c('div', {
    staticClass: "tabbar-item-icon-text"
  }, [_c('span', {
    staticClass: "icon-rantel-normal icon-default"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon-rantel-selected icon-active"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tabbar-item-label"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("租车")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "tabbar-item",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_c('div', {
    staticClass: "tabbar-item-icon-text"
  }, [_c('span', {
    staticClass: "icon-personal-normal icon-default"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-personal-selected icon-active"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tabbar-item-label"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("我的")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be886bc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tabbar/index.vue
// module id = 279
// module chunks = 107